import React, { useEffect, useState } from 'react';
import Player from './player';
import { usePlaywatchKids } from './Context';
import { ResourcePropertyType } from 'features/enumerations';
import { random_icons } from './random_icons';
import ColorToggleImage from './ColorToggleImage';
import { getIndexBasedOnHash } from './Header';
import './MainPlayContent.scss';

export default function MainPlayContent() {
    const { selectedMedia } = usePlaywatchKids();
    const [url, setUrl] = useState(null);
    const [profileImage, setProfileImage] = useState('/login-images/PlaywatchLineup.png');
    //Temporary
    useEffect(() => {
        let temp = getIndexBasedOnHash(random_icons, `${new Date().getUTCHours()}`);
        if (!profileImage) {
            setProfileImage(random_icons[temp]);
        }
    }, []);

    useEffect(() => {
        let state = selectedMedia.states.find(x => x.resourcePropertyType === ResourcePropertyType.MediaRel);
        if (state) {
            setUrl(state.url)
        }
    }, [selectedMedia?.id])

    if (url) {
        return (
            <>
                <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                    <Player url={url} />
                    <div style={{ display: 'flex', flexDirection: 'row' }} className='main-play-content'>
                        <div className='content-image'>
                            <div className='profile-image'>
                                <ColorToggleImage src={profileImage} startColorized={true} />
                            </div>
                        </div>
                        <div className='information'>
                            <div className={'title-card-name'}>{selectedMedia?.name}</div>
                            <div className={'title-card-description'}>{selectedMedia?.description}</div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return <></>
}